import React, { ReactNode, useState } from 'react'
import styles from '../../styles/admin/Main.module.scss'
import MainHeader from '../common/MainHeader'
import NavBar from '../common/Navbar'
import { useAuthStore } from '../../store/useAuthStore'

const AdminLayout = ({ children }) => {
  const user = useAuthStore((state) => state.user)
  const userRole = user?.STATUS === 'M' ? 'manager' : 'admin'
  const isStudent = user?.STATUS === 'O' || user?.STATUS === 'U'
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isStudent)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  const closeSidebar = () => {
    if (isStudent) setIsSidebarOpen(false)
  }

  return (
    <div className={`${styles.container} ${isStudent && !isSidebarOpen ? styles.noNav : ''}`}>
      <div className={styles.headerSection}>
        <MainHeader onToggleSidebar={toggleSidebar} isStudent={isStudent} />
      </div>
      {isSidebarOpen && (
        <>
          {isStudent && <div className={styles.overlay} onClick={closeSidebar} />}
          <div className={`${styles.navSection} ${isStudent ? styles.overlayNav : ''}`}>
            <NavBar userRole={userRole} isSidebarOpen={isSidebarOpen} />
          </div>
        </>
      )}
      <div className={styles.mainSection}>{children}</div>
    </div>
  )
}

export default AdminLayout
